import { useMemo } from "react";
import { buildShiftMetrics } from "../utils/shiftMetricsEngine";

export default function usePlannerMetrics({
  shiftsActive = [],
  shiftsForSelectedDay = [],
  workerPool = [],
  boardMetrics = {},
  selectedDayMs,
  startOfDayMs,
  ymd,
  roleKey,
  isWorkerAvailabilityBlocked,
}) {
  const liveOpsMetrics = useMemo(() => {
    const metrics = buildShiftMetrics(shiftsActive, {
      selectedDayMs,
      startOfDayMs,
      ymd,
    });

     return {
      coverage:
        metrics.coverage,

      total:
        metrics.total,

      covered:
        metrics.covered,

      open:
        metrics.open,

      offered:
        metrics.offered,

      requested:
        metrics.requested,

      timeRequired:
        metrics.timeRequired,

      openDemand:
        Number(metrics.open || 0) +
        Number(metrics.offered || 0) +
        Number(metrics.requested || 0) +
        Number(metrics.timeRequired || 0),

      assigned:
        metrics.assigned,

      acceptedAssigned:
        metrics.acceptedAssigned,

      awaitingAcceptance:
        metrics.awaitingAcceptance,

      activated:
        metrics.activated,

      tracking:
        metrics.tracking,

      arrived:
        metrics.arrived,

      completed:
        metrics.completed,

      hoursToday:
        metrics.actualHours,
    };

  }, [shiftsActive, selectedDayMs, startOfDayMs, ymd]);

  const staffingInsights = useMemo(() => {
    const insights = [];

    const openShifts = boardMetrics.uncovered || [];
    const byRole = {};

    for (const s of openShifts) {
      const rk = roleKey(s.role);

      if (!byRole[rk]) byRole[rk] = [];
      byRole[rk].push(s);
    }

    for (const rk of Object.keys(byRole)) {
      const count = byRole[rk];

      if (count.length >= 3) {
        insights.push({
          tone: "danger",
          label: `${count.length} ${rk} shifts uncovered`,
        });
      } else if (count.length >= 1) {
        insights.push({
          tone: "warn",
          label: `${count.length} ${rk} shift${count.length > 1 ? "s" : ""} still open`,
        });
      }
    }

    const actuallyAvailableWorkers = workerPool.filter((w) => {
      return !isWorkerAvailabilityBlocked(w);
    });

    const localAvailable = actuallyAvailableWorkers.filter((w) => {
      const state = String(w.state || "").trim().toUpperCase();
      return state === "TX";
    });

    if (localAvailable.length > 0) {
      insights.push({
        tone: "info",
        label: `${localAvailable.length} local workers available`,
      });
    }

    const topWorker = actuallyAvailableWorkers[0];

    if (topWorker) {
      insights.push({
        tone: "success",
        label: `Best available: ${topWorker.email || topWorker.uid}`,
      });
    }

    return insights.slice(0, 4);
  }, [workerPool, boardMetrics, roleKey, isWorkerAvailabilityBlocked]);

  return {
    liveOpsMetrics,
    staffingInsights,
  };
}